import { FC } from 'react';
import {
  TextBody,
  TextCaption,
  Spacer,
  Stack,
  Card,
  Icon,
  IconButton,
  Textarea,
  Tooltip,
  Input,
} from '@pypestream/design-system';
import { useFormContext } from 'react-hook-form';
import '../../modals/create-solution-modal/step-agent.scss';
import { useKnowledgeAgentUpload } from '../../../hooks';

interface UploadedFile {
  id: string;
  name: string;
  size: number;
  type: string;
  file: File | null;
  serverId?: string; // ID from server for existing files
}

interface TabAgentProps {
  uploadedFiles: UploadedFile[];
  addFile: (file: File) => void;
  removeFile: (fileId: string) => void;
}

export const TabAgent: FC<TabAgentProps> = ({
  uploadedFiles,
  addFile,
  removeFile,
}) => {
  const { register } = useFormContext();

  const { customFileUpload, formatFileSize, getFileIcon } =
    useKnowledgeAgentUpload({
      addFile,
    });

  return (
    <>
      <div>
        <Stack alignItems="center" gutter="2xsmall">
          <TextBody size="small">Brand Name</TextBody>
          <Tooltip
            placement="right"
            content="The name of your company or brand. This helps the model respond in a way that aligns with your brand identity."
          >
            <Icon name="info" color="gray" size="xsmall" />
          </Tooltip>
        </Stack>
        <Spacer size="2xsmall" />
        <Input
          variant="outlined"
          placeholder="Brand Name"
          {...register('brandName')}
        />
      </div>
      <Spacer />
      <div>
        <Stack alignItems="center" gutter="2xsmall">
          <TextBody size="small">Tone</TextBody>
          <Tooltip
            placement="right"
            content="Provide context or instructions for the knowledge agent to understand its role and capabilities."
          >
            <Icon name="info" color="gray" size="xsmall" />
          </Tooltip>
        </Stack>
        <Spacer size="2xsmall" />
        <Textarea
          variant="outlined"
          placeholder="Tone"
          rows={3}
          {...register('tone')}
        />
      </div>
      <Spacer />
      {customFileUpload}
      {uploadedFiles?.length > 0 && (
        <>
          <Spacer size="xsmall" />
          <div className="c-create-solution-agent__files-list c-create-solution-agent__files-list--panel">
            <Stack gutter="xsmall">
              {uploadedFiles?.map((file) => (
                <Card
                  key={file.id}
                  size="small"
                  shadow="none"
                  className="c-create-solution-agent__file c-create-solution-agent__file--large"
                >
                  <Icon
                    name={getFileIcon(file.name)}
                    className="c-create-solution-agent__file-icon"
                  />
                  <TextBody>{file.name}</TextBody>
                  <TextCaption>{formatFileSize(file.size)}</TextCaption>
                  {/* <IconButton
                    size="small"
                    name="show"
                    slot="hover-action-start"
                  /> */}
                  <IconButton
                    size="small"
                    name="delete"
                    slot="hover-action"
                    onClick={() => removeFile(file.id)}
                  />
                </Card>
              ))}
            </Stack>
          </div>
        </>
      )}
    </>
  );
};
